module.exports = {
  messages: {
    CN: {
      'hotwords.new': '新 建',
      'hotwords.remind': '温馨提示',
      'hotwords.remindcontent': '拖动行可以修改热词显示顺序',
      'hotwords.serialnumber': '序号',
      'hotwords.hotwordsname': '热词名称',
      'hotwords.searchTimes': '搜索次数',
      'hotwords.creater': '创建者',
      'hotwords.updatetime': '更新时间',
      'hotwords.operation': '操作',
      'hotwords.edit': '编辑',
      'hotwords.delete': '删除',
      'hotwords.newhotwords': '新建热词',
      'hotwords.edithotwords': '编辑热词',
      'hotwords.categoryname': '热词名称',
      'hotwords.suerdelete': '确定要删除吗？',
      'hotwords.determine': '确定',
      'hotwords.cancel': '取消',
      'hotwords.categorynameprop': '请输入热词名称',
      'hotwords.addfirstcategory': '新建热词'
    },
    JP: {
      'hotwords.new': '新規作成',
      'hotwords.remind': 'ヒント',
      'hotwords.remindcontent': '行をドラッグしてホットワードの表示順序を変更できます',
      'hotwords.serialnumber': '番号',
      'hotwords.hotwordsname': 'ホットワード名',
      'hotwords.searchTimes': '検索回数',
      'hotwords.creater': '作成者',
      'hotwords.updatetime': '更新時間',
      'hotwords.operation': '操作',
      'hotwords.edit': '編集',
      'hotwords.delete': '削除',
      'hotwords.newhotwords': '新規ホットワード',
      'hotwords.edithotwords': 'ホットワードを編集',
      'hotwords.categoryname': 'ホットワード検索',
      'hotwords.suerdelete': '削除してもよろしいですか？',
      'hotwords.determine': '確定',
      'hotwords.cancel': 'キャンセル',
      'hotwords.categorynameprop': 'ホットワード名を入力してください',
      'hotwords.addfirstcategory': '新規ホットワード'
    }
  }
};